import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class SrCrewService {
    constructor(private readonly datatask: DataTaskService) {}

    /** @datatask 1628 */
    public async getCrew(params: SrCrewParams): Promise<SrCrewGet> { return (await this.datatask.Post(1628, params))[0]; }
    /** @datatask 1629 */
    public async saveCrew(page: SrCrewGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1629, page))[0]; }
    /** @datatask 1773 */
    public async getMenu(params: SrCrewParams): Promise<SrCrewMenuGet> { return (await this.datatask.Post(1773, params))[0]; }
    /** @datatask 1774 */
    public getMemberships(params: Pick<SrCrewParams, 'srcrew_keyno'>): Promise<Item[]> { return this.datatask.Post(1774, params); }
    /** @datatask 1775 */
    public async getResource(params: SrCrewResourceParams): Promise<SrCrewResourceGet> { return (await this.datatask.Post(1775, params))[0]; }
    /** @datatask 1777 */
    public async saveResource(page: SrCrewResourceGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1777, page))[0]; }
    /** @datatask 1776 */
    public async deleteResource(page: SrCrewResourceGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1776, page))[0]; }
    /** @datatask 1820 */
    public async getResourceView(): Promise<SrCrewResourceViewGet> { return (await this.datatask.Post(1820, {}))[0]; }
    /** @datatask 1822 */
    public getMainResources(): Promise<Item[]> { return this.datatask.Post(1822, {}); }
    /** @datatask 1823 */
    public getSubResources(params: { main_resource_id: string; show_deactivated_resources?: string }): Promise<Item[]> { return this.datatask.Post(1823, params); }
    /** @datatask 1824 */
    public getResourceViews(params: { sub_resource_id: string }): Promise<Item[]> { return this.datatask.Post(1824, params); }
    /** @datatask 1627 */
    public async getCrews(params: SrCrewsParams): Promise<SrCrewsGet> { return (await this.datatask.Post(1627, params))[0]; }
    /** @datatask 1626 */
    public getCrewList(page: SrCrewsGet): Promise<Item[]> { return this.datatask.Post(1626, page); }
}

export interface SrCrewParams { resource_id: string; srcrew_keyno: string; }
export interface SrCrewGet extends SrCrewParams {
    resource_name: string;
    firstname: string;
    lastname: string;
    cellphone: string;
    email: string;
    private_car_regno: string;
    isactive: '0' | '1';
}
export interface SrCrewMenuGet extends SrCrewGet { cim_id: string; frr_id: string; }
export interface SrCrewResourceParams extends SrCrewParams { srcrewresource_keyno: string; }
export interface SrCrewResourceGet extends SrCrewResourceParams {
    fullname: string;
    resource_name: string;
    reg_datetime: string;
    reg_by_portal_user_name: string;
    show_button_save: '0' | '1';
    show_button_delete: '0' | '1';
}
export interface SrCrewResourceViewGet { main_resource_id: string; sub_resource_id: string; }
export interface SrCrewsParams { argtype: string; argvalue: string; }
export interface SrCrewsGet { search_resource_id: string; search_resource_name: string; searchtext: string; }
